@if (state !== ComponentState.READY && state !== ComponentState.NOT_FOUND) {
  <div class="container-fluid">
    {{ state }}
  </div>
}

@if (state === ComponentState.NOT_FOUND) {
  <div class="container-fluid">
    <h3 class="h3-xs">Session not found</h3>
    <p>
      Go to
      <a [routerLink]="routeService.getRouterLinkSessions()">Sessions</a>
      to open an existing session or to create a new one.
    </p>
  </div>
}

@if (state === ComponentState.READY) {
  <div class="session-view container-fluid">
    <as-split>
      <!-- split 1 -->
      <as-split-area [size]="split1Size" class="d-flex flex-column">
        <!-- workflow and files -->
        <ch-session-panel
          [sessionData]="sessionData"
          [modulesMap]="modulesMap"
          [tools]="tools"
          class="d-flex flex-column flex-grow-1"></ch-session-panel>
      </as-split-area>

      <!-- split 2-->
      <as-split-area id="myDiv" [size]="split2Size" class="scrollable">
        @if (!split3Visible) {
          <div>
            <div class="row">
              <div class="col">
                <ch-tools
                  [sessionData]="sessionData"
                  [toolsArray]="tools"
                  [modulesArray]="modules"
                  [modulesMap]="modulesMap"></ch-tools>
              </div>
            </div>

            <div class="row" id="visTab">
              <div class="col">
                <!-- TODO refactor logic choosing whether to show job or file or session info -->

                @if (selectionService.selectedDatasets.length < 1) {
                  <ch-session-details
                    [session]="sessionData.session"
                    [sessionData]="sessionData"
                    (deleteSession)="onDeleteSession()"></ch-session-details>
                }

                @if (selectionService.selectedDatasets.length > 0) {
                  <ch-selected-files
                    [dataset]="selectionService.selectedDatasets[0]"
                    [sessionData]="sessionData"
                    [tools]="tools"
                    (doScrollFix)="doScrollFix()"></ch-selected-files>
                }
              </div>
            </div>
          </div>
        } @else {
          <ch-selection-panel [sessionData]="sessionData" [tools]="tools"></ch-selection-panel>
        }
      </as-split-area>

      <!-- split 3-->
      @if (split3Visible) {
        <as-split-area [size]="split3Size" class="split-3 scrollable">
          <div class="row">
            <div class="col">
              <ch-tool-list-accordion
                [sessionData]="sessionData"
                [toolsArray]="tools"
                [modulesArray]="modules"></ch-tool-list-accordion>
            </div>
          </div>
        </as-split-area>
      }
    </as-split>
  </div>
}
